import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0Zm.8 5.6h-1.6v7.6H5.6v1.6h7.6v7.6h1.6v-7.6h7.6v-1.6h-7.6V5.6Z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }